export default __webpack_public_path__ + "static/kajaki-80cd6dbdb2dfcf0c717b507aef7c7e4c.png";